"use client";
import { useLanguage } from "@/hooks/use-language-context";
import { SettingData } from "@/types/settings";
import React from "react";

type Props = {
  data: SettingData;
};

const Privacy = ({ data }: Props) => {
  const { t } = useLanguage();

  console.log({data})
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-xl font-bold uppercase">{t("PrivacyPolicy")}</h2>

      {/* Wrapper pour forcer le style */}
      <div
        className="bg-white text-gray-800 text-base rounded-md"
        style={{
          fontSize: "16px", // taille de police fixe
          backgroundColor: "#ffffff", // couleur de fond forcée
          color: "#111827", // couleur du texte forcée
          lineHeight: "1.6",
        }}
        dangerouslySetInnerHTML={{
          __html: data?.politique,
        }}
      />
    </div>
  );
};

export default Privacy;
